import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import TriplePointTakeoverBackground from './components/TriplePointTakeoverBackground'
import TriplePointTakeoverHeroSubtitle from './components/TriplePointTakeoverHeroSubtitle'
import TriplePointTakeoverLogo from './components/TriplePointTakeoverLogo'
import TriplePointTakeoverSearchBanner from './components/TriplePointTakeoverSearchBanner'
import TriplePointTakeoverSearchTileBanner from './components/TriplePointTakeoverSearchTileBanner'

export const triplePointCampaignId = 'triple points june 2025'
export const triplePointsTakeoverId = 'societytriplepoints'

const societyTriplePointsTakeoverConfig: App.SiteTakeoverConfig = {
  id: triplePointsTakeoverId,
  verticals: new Set(['home', 'hotel', 'tours', 'cruise']),
  offerTypes: new Set<App.OfferType>([
    'hotel',
    'tactical_ao_hotel',
    'direct_tour',
    'partner_tour',
    'connection_tour',
    'partner_tour',
    'cruise',
  ]),
  campaignTags: new Set([triplePointCampaignId]),
  palette: 'default',
  backgroundElement: TriplePointTakeoverBackground,
  searchPage: {
    bannerContent: <TriplePointTakeoverSearchBanner />,
    tileBanner: <TriplePointTakeoverSearchTileBanner />,
  },
  offerPage: {
    bannerContent: <Group direction="horizontal" gap={12} verticalAlign="center">
      <TriplePointTakeoverLogo size="small" />
      <b>
        <FormattedMessage
          id="CbvER2mfgL"
          defaultMessage="Enjoy triple bonus points on this limited-time special offer."
          description="Offer page banner text for triple points takeover"
        />
      </b>
    </Group>,
  },
  heroSection: {
    title: <FormattedMessage
      id="ZG8Tibx6hc"
      defaultMessage="Curated escapes you’ll love"
      description="Hero section title for triple points takeover"
    />,
    subtitle: <TriplePointTakeoverHeroSubtitle />,
    logo: <CSSBreakpoint min="tablet"><TriplePointTakeoverLogo size="medium" /></CSSBreakpoint>,
    palette: 'default',
    verticals: new Set(['home']),
    filters: [
      {
        label: <FormattedMessage
          id="vjUvMc4ZvL"
          defaultMessage="Triple points"
          description="Filter label for triple points offers"
        />,
        value: triplePointCampaignId,
        type: 'campaignTag',
      },
      {
        label: <FormattedMessage
          id="eGzK2GAydd"
          defaultMessage="Dining & Drinks"
          description="Filter label for dining and drinks holiday type"
        />,
        value: 'Dining & Drinks',
        type: 'holidayType',
      },
      {
        label: <FormattedMessage
          id="FZqUItjxCx"
          defaultMessage="Family Friendly"
          description="Filter label for family friendly holiday type"
        />,
        value: 'Family Friendly',
        type: 'holidayType',
      },
    ],
  },
}

export default societyTriplePointsTakeoverConfig
